<template lang="pug">
table.tech-map-tab-table
  thead
    tr
      th
        span.column-header-title Обозн.
      th
        span.column-header-title Наим.
      th
        span.column-header-title Техн. Хар-ки
      th
        span.column-header-title Комментарий
  tbody
    tr(v-for="item in components", :key="`${item?.code} ${item?.name}`")
      td {{ item.code || "–" }}
      td {{ item.name || "–" }}
      td.properties-td
        table.properties-table
          tbody
            tr(v-for="prop in item.properties", :key="`${prop?.name} ${prop?.value}`")
              td {{ prop.name || "–" }}
              td {{ prop.value || "–" }}
      td {{ item.comment || "–" }}
</template>

<script setup>
// Возможно надо сносить. Данный компонент может быть отображен только если в компоненте floor_point переменная active будет true
// Функция назначающая переменную active true была закомментирована 3 года назад и соответственно этот компонент не может быть отображен
import { computed } from "vue";
const props = defineProps({
  parentData: {
    type: Object,
    default: () => ({}),
  },
});

const components = computed(() => props.parentData.tabs ?? []);
</script>

<style lang="scss"></style>
